export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-solid-900.ttf?10ecefc282f2761808bf26cb335511d5";